/**
 * Yuqori paneldagi filial tanlovi: owner va bir nechta filialli menejer uchun. Sahifalar qiymatni `scopedBranch`
 * orqali filtr sifatida yuboradi (doiradan tashqari qiymat -- masalan, shu qurilmadagi boshqa foydalanuvchidan
 * qolgani -- yuborilmaydi). Haqiqiy tekshiruv backend'da.
 */
import { useSyncExternalStore } from "react";
import type { Me } from "@/features/auth/types";

type ScopeOwner = Pick<Me, "role" | "scope_branches">;

/** Filial tanlovi kerakmi: owner -- doim, menejer -- bir nechta filiali bo'lsa */
export function canPickBranch(me: ScopeOwner): boolean {
  return me.role === "owner" || (me.role === "branch_manager" && me.scope_branches.length > 1);
}

/** Tanlangan filial, faqat foydalanuvchi uni tanlay olsa; aks holda undefined (butun doira) */
export function scopedBranch(me: ScopeOwner | undefined, branchId: number | null): number | undefined {
  if (!me || !branchId || !canPickBranch(me)) return undefined;
  if (me.role === "owner") return branchId;
  return me.scope_branches.some((b) => b.id === branchId) ? branchId : undefined;
}

const KEY = "dh.branchFilter";
let current: number | null = (() => {
  try {
    const v = localStorage.getItem(KEY);
    return v ? Number(v) : null;
  } catch {
    return null;
  }
})();
const listeners = new Set<() => void>();

export function useBranchFilter() {
  const branchId = useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => current,
  );
  return {
    branchId,
    setBranchId(id: number | null) {
      current = id;
      try {
        if (id) localStorage.setItem(KEY, String(id));
        else localStorage.removeItem(KEY);
      } catch {
        /* ixtiyoriy */
      }
      listeners.forEach((l) => l());
    },
  };
}
